import Config from 'Config';
import { Api } from 'Core';

const get = () => Api.get(`${Config.API_SERVER()}${Config.API_PATH_PREFIX}/campaigns/light_index`);

const getCampaign = (id = '') => Api.get(`${Config.API_SERVER()}${Config.API_PATH_PREFIX}/campaigns/${id}`);

export default { get, getCampaign };
